import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { LuChevronDown } from 'react-icons/lu';
import { ComuniTopic } from '../../constants';

type TopicModelsSectionProps = PropsWithChildren<{
  topic: ComuniTopic;
  count: number;
  isOpen: boolean;
  onToggle: () => void;
}>;

export const TopicModelsSection: FC<TopicModelsSectionProps> = ({ topic, count, isOpen, onToggle, children }) => {
  const { t } = useTranslation('comuni');

  return (
    <section className='rounded-xl border border-gray-200'>
      <button type='button' onClick={onToggle} className='flex w-full items-center justify-between gap-3 px-4 py-3 text-left bg-slate-100'>
        <span className='flex min-w-0 items-center gap-2'>
          <LuChevronDown className={`size-4 shrink-0 text-tertiary-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
          <span className='font-semibold'>{t(`topics.${topic}`)}</span>
          <span className='rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-tertiary-600'>{t('modelli.groupCount', { count })}</span>
        </span>
      </button>
      {isOpen ? <ul className='divide-y divide-gray-100 border-t border-gray-100'>{children}</ul> : null}
    </section>
  );
};
